import { render, staticRenderFns } from "./OtherSoftware.vue?vue&type=template&id=d8550b1e"
import script from "./OtherSoftware.vue?vue&type=script&lang=js"
export * from "./OtherSoftware.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports